import React, { useState } from "react";
import { useTonConnectUI } from "@tonconnect/ui-react";
import MotionModal from "@/components/atomics/motion-modal";
import ConnectWalletModal from "@/components/atomics/connect-wallet-modal";
import NftSuccessMessage from "@/components/atomics/nft-success-message";
import NftErrorMessage from "@/components/atomics/nft-error-message";
import StarVote from "@/components/atomics/star-vote";
import { useNavigate } from "react-router-dom";
import { CollectionStats } from "@/types/collection";
import { ItemDataType } from "@/types";

interface ModalSectionProps {
  stats: CollectionStats;
  showWalletConnectionModal: boolean;
  showSuccessMessage: boolean;
  showErrorMessage: boolean;
  walletAddress?: string;
  itemData?: ItemDataType;
  handleModalClose: () => void;
  previousExperience: number;
}

export default function ModalSection({
  stats,
  showWalletConnectionModal,
  showSuccessMessage,
  showErrorMessage,
  walletAddress,
  itemData,
  previousExperience,
  handleModalClose,
}: ModalSectionProps) {
  const navigate = useNavigate();
  const [tonConnectUI] = useTonConnectUI();

  const handleConnectWallet = async () => {
    try {
      await tonConnectUI.openModal();
    } catch (error) {
      console.error("Failed to open wallet connection modal:", error);
    }
  };

  const handleNavigateToNft = () => {
    handleModalClose();

    setTimeout(() => {
      navigate(`/nft/${stats.nextItemAddress}`);
    }, 100);
  };

  return (
    <div className="relative">
      <MotionModal isOpen={showWalletConnectionModal}>
        <ConnectWalletModal
          onClose={handleModalClose}
          onClick={handleModalClose}
          onConnect={handleConnectWallet}
        />
      </MotionModal>
      <MotionModal isOpen={showSuccessMessage}>
        <NftSuccessMessage
          className="w-full bg-black"
          avatar={stats.nft_image}
          videoUrl={stats.nft_image_content || ""}
          mimeType={stats.nft_image_type || ""}
          isSBT={stats.is_sbt}
          index={stats.minted_nfts}
          collectionName={stats.name}
          walletAddress={walletAddress}
          itemData={itemData}
          previousExperience={previousExperience}
          onClose={handleModalClose}
          onClick={handleNavigateToNft}
        />
      </MotionModal>
      <MotionModal isOpen={showErrorMessage}>
        <NftErrorMessage
          className="w-full bg-black"
          avatar={stats.image}
          videoUrl={stats.nft_image_content || ""}
          mimeType={stats.nft_image_type || ""}
          isSBT={stats.is_sbt}
          index={stats.minted_nfts}
          collectionName={stats.name}
          errorMessage="Error message"
          onClose={handleModalClose}
          onClick={handleModalClose}
        />
      </MotionModal>
      {/* <MotionModal isOpen={showStarVote}>
          <StarVote
            onClick={() => setShowStarVote(false)}
            onClose={() => setShowStarVote(false)}
          />
        </MotionModal> */}
    </div>
  );
}
